import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import RequestSingleUseBlockAnimatedCard from 'modules/expenses/components/cards/AnimatedCards/RequestSingleUseBlockAnimatedCard'

interface RequestSingleUseCardBlockProps {
  button: JSX.Element
}

const RequestSingleUseCardBlock = ({ button }: RequestSingleUseCardBlockProps) => {
  return (
    <>
      <Box
        width="full"
        height="full"
        justifyContent="center"
        alignItems="center"
        paddingX="s64"
        paddingY="s48"
        gap="s40"
        textAlign="center"
      >
        <Box flexDirection="column" gap="s8" maxWidth="s400">
          <Box paddingY="s24">
            <RequestSingleUseBlockAnimatedCard />
          </Box>
          <Text weight="medium" size="400" color="grey1000">
            {i18n.t('expenses_v2.cards.blocks.request_single_use_card.title')}
          </Text>
          <Text weight="normal" size="300" color="grey800">
            {i18n.t('expenses_v2.cards.blocks.request_single_use_card.description')}
          </Text>
        </Box>
        <Box flexDirection="column" gap="s32">
          {button}
        </Box>
      </Box>
    </>
  )
}

export default RequestSingleUseCardBlock
